<template>
  <v-card>
    <ValidateAll ref="form">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="6">
              <div class="headline">{{title()}}</div>
              <br />
              <!-- form goes here -->
              <v-skeleton-loader
                :loading="loading"
                class="actions__left"
                type="list-item-two-line,list-item-two-line, actions"
              >
                <Validate name="Nama Rekening Master" rules="required" #default="{ errors }">
                  <v-autocomplete
                    class="mb-3"
                    :items="list.rekeningMaster.data"
                    item-text="Nama"
                    item-value="IDMasterRekening"
                    name="Rekening Master"
                    label="Rekening Master"
                    :error-messages="errors"
                    placeholder="Nama Rekening Master"
                    v-model="form.IDMasterRekening"
                    :return-object="false"
                    outlined
                    hide-details="auto"
                    dense
                  >
                    <template v-slot:selection="data">
                      <v-text v-bind="data.attrs" :input-value="data.selected" @click="data.select">
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-text>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content v-text="data.item"></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title class="py-0">
                            {{data.item.Nama}}
                            &mdash;
                            <span
                              class="text--secondary"
                            >{{data.item.Kode}}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </Validate>
                <Validate name="Kode rekening" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Kode"
                    label="Kode"
                    :error-messages="errors"
                    placeholder="Kode rekening"
                    v-model="form.Kode"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Nama rekening" rules="required" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Nama"
                    label="Nama"
                    :error-messages="errors"
                    placeholder="Nama rekening"
                    v-model="form.Nama"
                    hide-details="auto"
                    outlined
                    required
                    dense
                  ></v-text-field>
                </Validate>
                <Validate name="Level" rules="required|min_value:1" #default="{ errors }">
                  <v-text-field
                    class="mb-3"
                    name="Level"
                    label="Level"
                    :error-messages="errors"
                    placeholder="Level"
                    v-model="form.Level"
                    hide-details="auto"
                    outlined
                    required
                    type="number"
                    min="1"
                    max="9"
                    dense
                  ></v-text-field>
                </Validate>

                <v-btn class="mr-2" @click="reset">Ulang</v-btn>
                <v-btn color="primary" @click="save()" :loading="saving">
                  <v-icon>mdi-content-save</v-icon>Simpan
                </v-btn>
              </v-skeleton-loader>
            </v-col>
            <v-divider vertical class="hidden-xs-only" />
            <v-col cols="12" md="6" class="mr-n1"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </ValidateAll>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    saving: false,
    loading: false,
    form: {
      Kode: "",
      Nama: "",
      IDMasterRekening: "",
      Level: 1
    }
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isRekeningMasterLoading"])
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/administration/rekening", this.form)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.$router.push("/rekening");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Rekening" : "Rekening Baru";
    },
    ...mapActions("list", ["refreshRekeningMaster"])
  },
  async mounted() {
    this.refreshRekeningMaster();
    let id = this.$route.params.id;
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/administration/rekening/${id}`)
        .then(res => {
          this.loading = false;
          this.form = { ...this.form, ...res.data.Data };
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    }
  }
};
</script>

<style>
</style>